/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgThumbsUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M10.473 1.695a.75.75 0 01.686-.445A3.75 3.75 0 0114.909 5v3.25h4.906a2.75 2.75 0 012.745 3.162l-1.38 9a2.75 2.75 0 01-2.745 2.338H4.159A2.75 2.75 0 011.409 20v-7a2.75 2.75 0 012.75-2.75H6.67l3.802-8.555zM7.91 11.16l3.715-8.36a2.25 2.25 0 011.785 2.2v4c0 .415.335.75.75.75h5.668a1.25 1.25 0 011.25 1.438l-1.38 9a1.25 1.25 0 01-1.25 1.063H7.91V11.159zm-1.5 10.09v-9.5h-2.25A1.25 1.25 0 002.909 13v7a1.25 1.25 0 001.25 1.25h2.25z'
      />
    </svg>
  );
}

export default SvgThumbsUp;
